import { Box, ListItemText, MenuItem } from '@mui/material';
import { color } from '@/colors';
import { CheckMarkIcon } from '@/UI/Icons';

const menuItemSx = {
  px: 1,
  py: 0.5,
  borderRadius: '4px',
  color: color.White100,
  minHeight: 'auto',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  '&:hover': { backgroundColor: color.White08_T },
};

const checkSlotSx = {
  width: 16,
  height: 16,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: color.White100,
  flexShrink: 0,
};

interface FormatMenuItemProps {
  label: string;
  active: boolean;
  disabled?: boolean;
  onSelect: () => void;
}

export function FormatMenuItem({ label, active, disabled, onSelect }: FormatMenuItemProps) {
  return (
    <MenuItem sx={menuItemSx} disabled={disabled} onClick={onSelect}>
      <ListItemText primaryTypographyProps={{ variant: 'body-sm-rg', color: color.White100 }} primary={label} />
      <Box sx={checkSlotSx}>{active && <CheckMarkIcon width={16} height={16} />}</Box>
    </MenuItem>
  );
}
